import { useState } from "react";
import { api, fmtBRL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

/** Edição (permissão acertos.A): só valor conferido e observação — as entregas do acerto não mudam. */
export function EditarAcertoForm({ acerto, onSaved }) {
  const [conferido, setConferido] = useState(acerto.valor_conferido == null ? "" : String(acerto.valor_conferido));
  const [obs, setObs] = useState(acerto.observacao || "");
  const [busy, setBusy] = useState(false);
  const conf = conferido === "" ? null : Number(conferido);
  const aReceber = acerto.totais?.a_receber || 0;
  const dif = conf == null || Number.isNaN(conf) ? null : Math.round((conf - aReceber) * 100) / 100;
  const salvar = async () => {
    setBusy(true);
    try {
      const r = await api.put(`/acertos/${acerto.id}`, { valor_conferido: conf != null && !Number.isNaN(conf) ? conf : null, observacao: obs || null });
      toast.success("Acerto atualizado");
      onSaved?.(r.data);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro ao salvar"); }
    finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50/60 p-3 grid grid-cols-1 md:grid-cols-[180px_1fr_auto] gap-3 items-end" data-testid="acerto-editar-form">
      <div className="space-y-1">
        <Label className="text-xs">Dinheiro conferido</Label>
        <Input type="number" step="0.01" inputMode="decimal" value={conferido} onChange={(e) => setConferido(e.target.value)} className="mono h-9" data-testid="acerto-editar-conferido" />
        {dif != null && <div className={`text-xs font-bold mono ${dif === 0 ? "text-emerald-700" : dif < 0 ? "text-rose-700" : "text-sky-700"}`} data-testid="acerto-editar-diferenca" data-dif={dif}>
          {dif === 0 ? "✓ Bateu certinho" : dif < 0 ? `Faltam ${fmtBRL(-dif)}` : `Sobra de ${fmtBRL(dif)}`}</div>}
      </div>
      <div className="space-y-1">
        <Label className="text-xs">Observação</Label>
        <Textarea rows={1} value={obs} onChange={(e) => setObs(e.target.value)} className="min-h-9" data-testid="acerto-editar-observacao" />
      </div>
      <Button size="sm" onClick={salvar} disabled={busy} className="h-9 bg-sky-700 hover:bg-sky-800" data-testid="acerto-editar-salvar">
        {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />}Salvar
      </Button>
    </div>
  );
}
